import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import Header from './components/layout/Header';
import ProtectedRoute from './components/ProtectedRoute';
import ProtectedAdminRoute from './components/admin/ProtectedAdminRoute';
import AdminLayout from './components/admin/AdminLayout';
import Home from './pages/Home';
import About from './pages/About';
import Login from './pages/Login';
import Configurator from './pages/Configurator';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Profile from './pages/Profile';
import OrderSuccess from './pages/OrderSuccess';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminOrders from './pages/admin/AdminOrders';
import AdminComponents from './pages/admin/AdminComponents';
import AdminTickets from './pages/admin/AdminTickets';
import AdminCoupons from './pages/admin/AdminCoupons';
import AdminSettings from './pages/admin/AdminSettings';
import './App.css';

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <div className="app">
      {!isAdminRoute && <Header />}
      <main className={`app-main ${isAdminRoute ? 'admin-page' : ''}`}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/login" element={<Login />} />
                <Route path="/design" element={<Configurator />} />
                <Route path="/cart" element={<Cart />} />
                <Route
                  path="/checkout"
                  element={
                    <ProtectedRoute>
                      <Checkout />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <Profile />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/order-success"
                  element={
                    <ProtectedRoute>
                      <OrderSuccess />
                    </ProtectedRoute>
                  }
                />
                {/* Admin Routes */}
                <Route
                  path="/admin"
                  element={
                    <ProtectedAdminRoute>
                      <AdminLayout>
                        <AdminDashboard />
                      </AdminLayout>
                    </ProtectedAdminRoute>
                  }
                />
                <Route
                  path="/admin/orders"
                  element={
                    <ProtectedAdminRoute>
                      <AdminLayout>
                        <AdminOrders />
                      </AdminLayout>
                    </ProtectedAdminRoute>
                  }
                />
                <Route
                  path="/admin/orders/:orderId"
                  element={
                    <ProtectedAdminRoute>
                      <AdminLayout>
                        <AdminOrders />
                      </AdminLayout>
                    </ProtectedAdminRoute>
                  }
                />
                <Route
                  path="/admin/components"
                  element={
                    <ProtectedAdminRoute>
                      <AdminLayout>
                        <AdminComponents />
                      </AdminLayout>
                    </ProtectedAdminRoute>
                  }
                />
                <Route
                  path="/admin/components/:type"
                  element={
                    <ProtectedAdminRoute>
                      <AdminLayout>
                        <AdminComponents />
                      </AdminLayout>
                    </ProtectedAdminRoute>
                  }
                />
                <Route
                  path="/admin/coupons"
                  element={
                    <ProtectedAdminRoute>
                      <AdminLayout>
                        <AdminCoupons />
                      </AdminLayout>
                    </ProtectedAdminRoute>
                  }
                />
                <Route
                  path="/admin/settings"
                  element={
                    <ProtectedAdminRoute>
                      <AdminLayout>
                        <AdminSettings />
                      </AdminLayout>
                    </ProtectedAdminRoute>
                  }
                />
                <Route
                  path="/admin/support"
                  element={
                    <ProtectedAdminRoute>
                      <AdminLayout>
                        <AdminTickets />
                      </AdminLayout>
                    </ProtectedAdminRoute>
                  }
                />
                <Route
                  path="/admin/support/:ticketId"
                  element={
                    <ProtectedAdminRoute>
                      <AdminLayout>
                        <AdminTickets />
                      </AdminLayout>
                    </ProtectedAdminRoute>
                  }
                />
              </Routes>
            </main>
          </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;

